import { render } from "./widgetWindDirection.vue?vue&type=template&id=1460b1c1&scoped=true"
import script from "./widgetWindDirection.vue?vue&type=script&lang=js"
export * from "./widgetWindDirection.vue?vue&type=script&lang=js"

import "./widgetWindDirection.vue?vue&type=style&index=0&id=1460b1c1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1460b1c1"]])

export default __exports__